import React from 'react';

import { useTranslation } from 'react-i18next';
import { subscriptionsEntityTransformer } from '../../../utils/transformers';
import DataGrid from '../../DataGrid/DataGrid';
import { PaginationMode } from '../../DataGrid/types';
import {
    generateColumns,
    SubscriptionsTableRowInterface,
    useStyles,
} from './Subscriptions.utils';
import { TransactionTableInterface } from '../utils';
import classNames from 'classnames';

const Subscriptions: React.VFC<TransactionTableInterface> = ({
    currency,
    data,
    onPageChange,
    onPageSizeChange,
    initialPageSize,
    loading,
    rowCount,
    userDateTimeFormat,
    className,
}) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const columns = generateColumns(t, currency, userDateTimeFormat);

    const items: SubscriptionsTableRowInterface[] = data.map(
        subscriptionsEntityTransformer,
    );

    return (
        <DataGrid<SubscriptionsTableRowInterface>
            data={items}
            loading={loading}
            columns={columns}
            rowCount={rowCount}
            paginationMode={PaginationMode.Server}
            onPageChange={onPageChange}
            onPageSizeChange={onPageSizeChange}
            initialPageSize={initialPageSize}
            dataQa={'subscriptions-table'}
            classes={{
                header: classes.header,
                tableContainer: classNames(classes.tableContent, className),
            }}
        />
    );
};

export default Subscriptions;
